// Shared category catalog — single source of truth for the seven seeded
// category slugs and their bilingual labels. Customer code calls
// `categoryLabel(slug, locale)` to render chips and detail-page pills; the
// admin wizard imports `CATEGORIES` as the seed list for its multi-select.
//
// Adding a category:
//   1. Append a new `{ slug, en, th }` entry below.
//   2. Re-seed (`tooling/scripts/seed-content.ts`) so existing series can
//      attach the new slug.
//   3. No string-key plumbing needed — the labels live here, not in the
//      i18n catalog, because they're bound 1:1 to a DB slug.

export interface Category {
  slug: string;
  en: string;
  th: string;
}

export const CATEGORIES: Category[] = [
  { slug: "bl", en: "BL", th: "วาย / BL" },
  { slug: "drama", en: "Drama", th: "ดราม่า" },
  { slug: "school", en: "School", th: "โรงเรียน" },
  { slug: "romance", en: "Romance", th: "โรแมนติก" },
  { slug: "slice-of-life", en: "Slice of life", th: "ชีวิตประจำวัน" },
  { slug: "office", en: "Office", th: "ออฟฟิศ" },
  { slug: "summer", en: "Summer", th: "ฤดูร้อน" },
];

/**
 * Render the bilingual label for a category slug. If the slug isn't in the
 * canonical list (e.g. an admin-added custom tag), fall back to a humanized
 * version of the slug so the UI never shows `slice-of-life` as raw text.
 */
export function categoryLabel(slug: string, locale: "th" | "en"): string {
  const found = CATEGORIES.find((c) => c.slug === slug);
  return found ? found[locale] : slug.replace(/-/g, " ");
}
